var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 712,
    height: 562,
    viewBox: "0 0 712 562",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M607.316 186.675C607.316 186.675 551.142 173.208 559.592 123.141C568.043 73.0734 459.62 10.9557 342.206 52.2597C224.791 93.5637 352.456 226.325 238.367 251.788C124.277 277.251 90.5522 488.609 380.816 508.66C671.08 528.711 720.83 353.322 709.973 271.292C699.117 189.262 607.316 186.675 607.316 186.675Z",
    fill: "url(#paint0_linear_129_10769)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M493.859 446.446C493.859 446.446 480.292 440.261 481.893 463.561C483.494 486.861 487.084 517.318 474.898 543.799C474.898 519.73 475.259 417.35 475.259 417.35L493.859 446.446Z",
    fill: "#D6BBFB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M627.381 410.405L675.247 410.909C675.247 410.909 618.521 410.608 616.523 428.66C614.526 446.711 543.81 419.435 536.622 439.89C529.433 460.345 474.3 456.74 474.898 410.405",
    fill: "#D6BBFB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M571.526 444.909C571.526 444.909 553.005 430.665 546.01 446.517C539.015 462.368 583.255 448.116 571.526 444.909Z",
    fill: "#D6BBFB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M512.451 187.85C512.451 187.85 484.093 173.086 477.098 176.761C470.103 180.437 488.879 190.961 496.173 191.862C503.468 192.763 518.848 192.357 512.451 187.85Z",
    fill: "#1C1C1C",
    stroke: "#1C1C1C",
    strokeWidth: 1.36
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M463.618 223.856C466.724 216.266 469.056 199.858 472.144 188.893C479.438 201.714 501.022 203.772 509.02 204.082C504.673 214.269 501.4 223.361 501.981 228.371C502.746 234.733 509.741 234.176 515.98 232.347C521.259 230.81 532.152 225.279 532.152 225.279C532.152 225.279 519.913 237.437 513.164 243.374C510.19 250.098 502.729 259.111 486.864 269.661C447.534 295.868 458.119 237.295 463.618 223.856Z",
    fill: "#7F56D9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M463.618 223.856C466.724 216.266 469.056 199.858 472.144 188.893C479.438 201.714 501.022 203.772 509.02 204.082C504.673 214.269 501.4 223.361 501.981 228.371C502.746 234.733 509.741 234.176 515.98 232.347C521.259 230.81 532.152 225.279 532.152 225.279C532.152 225.279 519.913 237.437 513.164 243.374C510.19 250.098 502.729 259.111 486.864 269.661C447.534 295.868 458.119 237.295 463.618 223.856V223.856Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.36
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M469.654 249.135C465.536 244.708 462.484 239.391 460.732 233.593C461.448 230.284 462.412 227.035 463.618 223.874C466.724 216.284 469.056 199.876 472.144 188.911C476.957 197.366 487.982 201.139 497.221 202.818C491.301 207.265 488.197 214.55 489.082 221.921C490.305 234.583 501.673 247.341 531.835 225.455L532.169 225.296C532.169 225.296 519.93 237.454 513.182 243.392C511.422 247.35 508.105 252.104 502.438 257.529C491.51 261.205 479.553 259.817 469.654 249.135Z",
    fill: "#42307D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M472.144 188.893C474.52 180.455 477.344 175.242 481.295 179.73C483.49 182.029 486.143 183.835 489.082 185.032C497.678 188.858 509.266 190.148 515.012 190.572C512.962 195.122 510.894 199.699 509.02 204.082C501.022 203.772 479.438 201.696 472.144 188.893Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M481.295 179.73C483.49 182.029 486.143 183.835 489.082 185.032C489.962 185.403 490.841 185.748 491.721 186.083C489.962 187.683 487.771 190.501 489.082 193.868C490.982 198.674 506.169 198.895 508.782 204.073C500.599 203.728 479.368 201.59 472.144 188.893C474.52 180.49 477.344 175.242 481.295 179.73Z",
    fill: "#AFC0F9"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M472.144 188.893C474.52 180.455 477.344 175.242 481.295 179.73C483.49 182.029 486.143 183.835 489.082 185.032C497.678 188.858 509.266 190.148 515.012 190.572C512.962 195.122 510.894 199.699 509.02 204.082C501.022 203.772 479.438 201.696 472.144 188.893V188.893Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.36
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M501.163 156.563C500.362 150.042 503.565 143.309 514.95 150.245C521.52 154.065 524.987 161.622 523.608 169.119L523.547 169.596C523.08 172.75 519.341 180.985 515.021 190.572C509.275 190.148 497.687 188.858 489.091 185.032C493.692 164.807 501.91 162.651 501.163 156.563Z",
    fill: "#F97ACC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M501.03 158.754C502.486 157.845 504.22 157.493 505.914 157.765C514.95 159.373 520.625 165.576 515.988 167.184C515.988 167.184 507.823 166.636 502.79 170.577C500.96 168.5 497.15 167.926 494.757 175.118C492.363 182.31 501.109 185.907 506.477 185.376C511.034 184.926 515.786 187.214 514.624 190.537C508.764 190.095 497.484 188.769 489.108 185.032C493.085 167.396 499.851 163.499 501.03 158.754Z",
    fill: "#D3099F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M501.163 156.563C500.362 150.042 503.565 143.309 514.95 150.245C521.52 154.065 524.987 161.622 523.608 169.119L523.547 169.596C523.08 172.75 519.341 180.985 515.021 190.572C509.275 190.148 497.687 188.858 489.091 185.032C493.692 164.807 501.91 162.651 501.163 156.563V156.563Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.36
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M550.805 174.261L393.201 142.222L410.983 98.4943L550.805 166.689V174.261Z",
    fill: "#E0CCFC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M411.863 119.523L418.559 102.179L420.398 103.062C421.788 106.261 423.258 112.976 419.087 123.968C412.928 140.217 456.658 135.631 456.359 144.29C456.06 152.949 469.24 137.504 474.185 139.598C479.13 141.692 472.496 154.911 487.674 155.759C502.852 156.607 512.161 166.212 515.047 162.757C517.933 159.302 520.863 156.262 522.244 159.222C523.626 162.182 537.915 169.171 548.042 169.242C549.037 169.203 550.017 169.485 550.84 170.046V174.305L401.974 143.998L411.863 119.523Z",
    fill: "#B699ED"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M550.806 174.261L393.202 142.222L410.984 98.4943L550.806 166.689V174.261Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.36
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M507.154 144.316L500.238 163.923L507.154 144.316Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M507.154 144.316L500.238 163.923",
    stroke: "#1C1C1C",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M537.625 160.124L533.849 170.815L537.625 160.124Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M537.625 160.124L533.849 170.815",
    stroke: "#1C1C1C",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M554.404 158.118C554.404 158.118 525.491 192.577 556.357 198.886C552.908 211.071 542.121 224.457 552.758 226.569C563.396 228.68 583.774 227.32 582.12 198.886C580.466 170.453 570.629 138.078 554.404 158.118Z",
    fill: "#F97ACC",
    stroke: "#1C1C1C",
    strokeWidth: 1.36
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M484.894 187.629C484.894 187.629 439.316 169.896 441.516 179.73C443.715 189.564 482.148 192.719 484.894 187.629Z",
    fill: "#1C1C1C",
    stroke: "#1C1C1C",
    strokeWidth: 1.36
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M567.338 173.758C567.338 173.758 572.283 161.573 565.236 161.723C558.188 161.874 543.239 162.607 545.465 144.573C547.691 126.539 593.119 132.989 598.794 188.186C599.542 202.801 553.999 209.118 567.338 173.758Z",
    fill: "#7F56D9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M545.465 144.573C546.301 137.813 553.199 134.491 561.786 135.878C558.742 138.529 553.973 144.272 556.402 152.852C559.842 165.036 573.709 154.769 572.019 165.469C570.33 176.169 571.826 194.548 587.408 189.573C593.444 187.647 596.929 187.152 598.733 187.603C598.733 187.806 598.777 187.992 598.794 188.186C599.542 202.8 553.999 209.118 567.338 173.757C567.338 173.757 572.283 161.573 565.236 161.723C558.188 161.873 543.212 162.633 545.465 144.573Z",
    fill: "#6445B1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M567.338 173.758C567.338 173.758 572.283 161.573 565.236 161.723C558.188 161.874 543.239 162.607 545.465 144.573C547.691 126.539 593.119 132.989 598.794 188.186C599.542 202.801 553.999 209.118 567.338 173.758Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.36
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M509.653 280.891C509.653 280.891 502.87 304.297 478.101 308.706C453.332 313.115 508.061 341.204 527.436 329.568C546.811 317.931 545.412 256.478 509.653 280.891Z",
    fill: "#F98216",
    stroke: "#1C1C1C",
    strokeWidth: 1.36
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M509.653 280.891C509.653 280.891 502.87 304.297 478.101 308.706C453.332 313.115 508.061 341.204 527.436 329.568C546.811 317.931 545.412 256.478 509.653 280.891Z",
    fill: "#7F56D9",
    stroke: "#1C1C1C",
    strokeWidth: 1.36
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M593.119 213.395C593.119 213.395 585.2 191.862 549.662 214.464C554.466 218.961 594.826 219.951 593.119 213.395Z",
    fill: "#7F56D9",
    stroke: "#1C1C1C",
    strokeWidth: 1.36
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M457.811 188.124C462.905 172.741 467.964 160.654 466.812 156.059C463.415 142.505 467.692 144.926 470.208 145.73C471.457 137.283 477.071 138.989 476.499 142.505C483.591 135.976 486.09 139.916 485.087 143.318C490.982 141.118 494.378 143.822 494.273 146.331C487.286 147.939 483.714 154.752 485.087 159.17C486.459 163.587 496.974 157.667 500.168 160.937C503.362 164.206 490.683 162.244 485.087 186.711C485.025 187.011 484.972 187.294 484.92 187.594C480.221 188.822 469.187 190.943 457.811 188.124Z",
    fill: "#F97ACC"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M471.458 184.21C477.159 183.176 481.884 185.809 484.462 187.744C479.553 188.955 468.853 190.872 457.811 188.133C462.905 172.75 467.965 160.663 466.812 156.068C464.304 146.066 465.985 144.767 468.044 145.094C468.044 145.244 467.991 145.395 467.938 145.562C466.381 150.599 469.205 155.414 471.458 159.479C473.71 163.543 462.765 185.792 471.458 184.21Z",
    fill: "#D3099F"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M457.81 188.124C462.905 172.741 467.964 160.654 466.812 156.059C463.415 142.505 467.692 144.926 470.208 145.73C471.457 137.283 477.071 138.989 476.499 142.505C483.591 135.976 486.09 139.916 485.087 143.318C490.982 141.118 494.378 143.822 494.273 146.331C487.286 147.939 483.714 154.752 485.087 159.17C486.459 163.587 496.974 157.667 500.168 160.937C503.362 164.206 490.683 162.244 485.087 186.711C485.025 187.011 484.972 187.294 484.92 187.594C480.221 188.822 469.187 190.943 457.81 188.124V188.124Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.36
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M512.838 287.774C512.838 287.774 507.031 308.22 496.569 307.796C486.108 307.372 480.863 305.666 479.57 310.897C478.277 316.128 493.419 332.324 511.642 318.894C529.864 305.463 525.896 280.122 512.838 287.774Z",
    fill: "#6445B1"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M356.545 295.046C415.779 253.315 498.267 317.135 498.267 317.135C498.267 317.135 523.441 319.945 518.443 334.179C513.445 348.414 422.765 320.926 422.765 320.926C416.606 314.652 383.382 301.355 355.938 295.47L356.545 295.046Z",
    fill: "#7F56D9"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M360.83 292.245C361.613 291.768 362.405 291.299 363.197 290.858C363.567 290.646 363.927 290.442 364.297 290.248C365.177 289.78 366.057 289.364 366.937 288.896L367.693 288.516C368.82 287.986 369.946 287.482 371.081 287.005L371.961 286.67C372.841 286.316 373.721 285.98 374.6 285.671L375.753 285.265C376.571 284.982 377.398 284.717 378.225 284.461L379.273 284.142C380.425 283.816 381.578 283.497 382.73 283.259L383.038 283.188C384.103 282.932 385.168 282.711 386.232 282.499L387.367 282.296C388.186 282.146 389.004 282.013 389.831 281.889L391.001 281.721C391.934 281.598 392.867 281.483 393.799 281.395C394.046 281.395 394.292 281.333 394.538 281.315C395.7 281.2 396.87 281.121 398.058 281.059H399.026C399.906 281.015 400.786 280.988 401.665 280.979H402.853C403.733 280.979 404.543 280.979 405.396 280.979H406.417C407.587 281.023 408.748 281.076 409.936 281.156H410.403C411.423 281.227 412.435 281.315 413.456 281.421L414.556 281.536L417.046 281.836L418.137 281.987C419.122 282.128 420.099 282.278 421.076 282.437L421.595 282.526C422.747 282.72 423.9 282.941 425.044 283.162L425.924 283.347C426.804 283.524 427.683 283.71 428.502 283.913L429.549 284.151C430.429 284.355 431.309 284.567 432.144 284.787L432.945 284.991C434.071 285.291 435.198 285.6 436.315 285.918L436.641 286.016C437.644 286.307 438.638 286.608 439.632 286.899L440.512 287.173C441.392 287.438 442.193 287.712 443.029 287.995L443.829 288.26C446.011 289.008 448.155 289.789 450.261 290.601L450.789 290.813C451.669 291.158 452.549 291.503 453.429 291.856L454.089 292.13C455.013 292.51 455.928 292.89 456.834 293.279L457.098 293.394C459.168 294.283 461.178 295.193 463.125 296.124L463.53 296.309C464.41 296.725 465.289 297.149 466.125 297.564L466.372 297.688C468.307 298.642 470.173 299.596 471.968 300.55C471.853 300.55 410.596 276.349 372.867 299.729C367.236 298.094 361.569 296.636 356.149 295.47L356.756 295.028C357.847 294.259 358.939 293.544 360.038 292.846L360.83 292.245Z",
    fill: "#42307D"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M551.702 406.8C551.702 406.8 573.488 426.124 571.544 418.844C569.555 411.413 559.393 389.747 559.393 389.747L551.702 406.8Z",
    fill: "#1C1C1C",
    stroke: "#1C1C1C",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M355.938 295.488L356.545 295.046C415.779 253.315 498.267 317.135 498.267 317.135C498.267 317.135 523.441 319.945 518.443 334.179C513.445 348.414 422.765 320.926 422.765 320.926",
    stroke: "#1C1C1C",
    strokeWidth: 1.36
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M372.427 343.607C401.789 299.384 513.551 325.255 513.551 325.255C546.793 322.605 584.267 351.135 568.983 408.002C473.701 431.169 439.245 395.968 432.356 377.607C432.356 377.607 444.041 415.221 474.898 432.389C474.203 443.08 461.524 456.528 445.862 466.654C433.06 474.942 418.278 481.003 406.47 481.498C398.017 467.817 390.446 453.607 383.804 438.954C367.755 403.213 358.252 364.963 372.427 343.607Z",
    fill: "#7F56D9"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M499.473 399.617C531.228 401.19 527.04 377.121 537.422 387.344C547.805 397.567 552.556 383.094 538.54 367.72C549.688 372.049 566.397 384.278 571.526 395.853C570.909 399.951 570.06 404.01 568.984 408.011C473.701 431.178 439.245 395.977 432.356 377.616C426.725 364.203 424.56 347.831 424.56 347.831C424.692 348.697 434.952 397.231 499.473 399.617Z",
    fill: "#42307D"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M372.427 343.607C395.084 309.492 466.759 317.1 498.347 322.348C474.88 321.898 425.167 322.56 415.172 335.787C401.991 353.238 393.386 369.089 397.785 386.363C402.185 403.637 386.347 401.605 386.083 413.242C385.819 424.878 388.987 462.351 422.765 458.348C453.983 454.637 471.466 432.725 474.449 432.106L474.898 432.371C474.203 443.062 461.524 456.51 445.862 466.636C433.06 474.924 418.278 480.985 406.47 481.48C398.017 467.8 390.446 453.589 383.804 438.936C367.755 403.213 358.252 364.963 372.427 343.607Z",
    fill: "#42307D"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M372.427 343.607C401.789 299.384 513.551 325.256 513.551 325.256C546.793 322.605 584.267 351.135 568.983 408.002C473.701 431.17 439.245 395.968 432.356 377.607C432.356 377.607 444.041 415.221 474.898 432.389C474.203 443.08 461.524 456.528 445.862 466.654C433.06 474.942 418.278 481.003 406.47 481.498C398.017 467.818 390.446 453.607 383.804 438.954C367.755 403.213 358.252 364.963 372.427 343.607Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.36
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M525.535 266.286C525.535 266.286 517.44 304.801 498.258 317.135C509.547 323.957 520.132 337.891 520.132 337.891C520.132 337.891 563.246 306.126 558.486 286.961C553.726 267.797 533.929 253.041 525.535 266.286Z",
    fill: "white",
    stroke: "#1C1C1C",
    strokeWidth: 1.36
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M496.094 295.028H496.165C486.803 294.145 477.344 291.556 469.258 286.944C477.737 291.005 486.789 293.732 496.094 295.028Z",
    fill: "white",
    stroke: "#1C1C1C",
    strokeWidth: 1.36
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M496.163 295.046C497.572 295.178 498.98 295.267 500.379 295.32C498.968 295.402 497.552 295.31 496.163 295.046Z",
    fill: "white",
    stroke: "#1C1C1C",
    strokeWidth: 1.36
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M516.243 187.85C520.027 179.447 523.115 172.45 523.538 169.596C524.734 161.476 521.646 156.66 520.018 158.993C518.39 161.325 517.273 167.731 517.273 167.731C517.273 167.731 503.415 164.55 498.021 176.788",
    fill: "#F97ACC"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M516.243 187.85C520.027 179.447 523.115 172.45 523.538 169.596C524.734 161.476 521.646 156.66 520.018 158.993C518.39 161.325 517.273 167.731 517.273 167.731C517.273 167.731 503.415 164.55 498.021 176.788",
    stroke: "#1C1C1C",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M526.248 154.716C526.248 154.716 523.608 145.103 509.046 143.15C497.66 142.47 497.775 156.952 503.846 152.869C505.306 155.008 506.573 155.617 508.448 154.301C508.709 155.119 509.371 155.745 510.2 155.959C511.029 156.172 511.909 155.943 512.53 155.352C513.876 153.921 512.882 160.592 517.264 158.003C521.646 155.414 523.529 153.647 526.248 154.716V154.716Z",
    fill: "#F97ACC"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M509.055 143.15L509.539 143.221C506.585 143.823 504.059 145.732 502.667 148.416C499.376 154.752 514.721 148.416 515.742 158.577C513.102 158.869 513.7 154.098 512.539 155.335C511.917 155.926 511.037 156.154 510.209 155.941C509.38 155.727 508.718 155.102 508.456 154.283C506.582 155.6 505.315 154.99 503.855 152.852C497.783 156.952 497.669 142.496 509.055 143.15Z",
    fill: "#D3099F"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M526.248 154.716C526.248 154.716 523.608 145.103 509.046 143.15C497.66 142.47 497.775 156.952 503.846 152.87C505.306 155.008 506.573 155.617 508.448 154.301C508.709 155.119 509.371 155.745 510.2 155.959C511.029 156.172 511.909 155.943 512.53 155.352C513.876 153.921 512.882 160.592 517.264 158.003C521.646 155.414 523.529 153.647 526.248 154.716V154.716Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M503.853 152.852C503.853 152.852 504.566 146.755 507.972 145.554",
    stroke: "#1C1C1C",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M508.455 154.283C508.918 151.345 510.776 148.816 513.437 147.506",
    stroke: "#1C1C1C",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M513.05 155.193C513.05 155.193 515.839 149.627 519.913 150.139",
    stroke: "#1C1C1C",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M485.087 143.318C481.014 146.783 478.546 151.784 478.268 157.137",
    stroke: "#1C1C1C",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M476.5 142.496C476.5 142.496 472.724 147.126 473.481 155.75",
    stroke: "#1C1C1C",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M470.208 145.73C470.065 147.851 470.065 149.98 470.208 152.101V145.73Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M470.208 145.73C470.065 147.851 470.065 149.98 470.208 152.101",
    stroke: "#1C1C1C",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M261.079 397.32C266.666 399.431 280.058 415.574 290.933 431.867C297.866 442.267 299.441 448.479 299.406 452.013C280.102 440.915 257.621 403.478 261.079 397.32Z",
    fill: "#1C1C1C",
    stroke: "#1C1C1C",
    strokeWidth: 1.36
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M317.716 405.581C317.716 405.581 373.439 447.56 368.494 432.088C363.549 416.617 331.794 377.855 323.215 384.596C314.637 391.338 317.716 405.581 317.716 405.581Z",
    fill: "#1C1C1C",
    stroke: "#1C1C1C",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M421.005 318.575C414.846 312.302 383.382 301.372 355.938 295.487C319.775 321.244 310.299 352.717 305.53 376.882C321.292 382.754 335.639 391.904 347.632 403.734C356.134 412.163 363.197 421.94 368.538 432.671C368.635 428.863 380.654 370.53 421.005 318.575Z",
    fill: "#7F56D9"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M355.938 295.487C361.508 296.68 367.236 298.085 372.894 299.614C369.259 301.829 365.9 304.472 362.889 307.486C327.184 343.307 360.874 356.251 347.623 368.586C334.372 380.92 375.428 397.452 368.529 432.062C368.529 432.212 368.468 432.345 368.441 432.486C364.357 424.315 359.267 416.692 353.29 409.796L353.052 409.539C352.196 408.556 351.339 407.604 350.483 406.685C349.542 405.669 348.583 404.689 347.623 403.734C335.633 391.906 321.288 382.755 305.53 376.882C310.299 352.717 319.775 321.244 355.938 295.487V295.487Z",
    fill: "#42307D"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M356.22 295.275C320.057 321.04 310.299 352.708 305.53 376.882C321.292 382.754 335.64 391.904 347.633 403.734C356.134 412.163 363.197 421.94 368.539 432.671C368.644 428.863 379.907 371.395 420.258 319.441",
    stroke: "#1C1C1C",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M420.249 319.441C420.249 319.441 427.86 310.668 433.447 305.852C432.47 306.736 429.532 316.455 434.072 318.09C429.294 318.425 421.173 318.973 420.249 319.441Z",
    fill: "#1C1C1C",
    stroke: "#1C1C1C",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M409.565 91.5156L389.769 146.611C398.07 149.619 407.227 145.3 410.222 136.964L419.181 112.03C422.159 103.699 417.856 94.5197 409.565 91.5156V91.5156Z",
    fill: "#7F56D9"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M410.359 113.286C405.669 129.817 408.186 134.112 411.653 132.954L410.227 136.93C408.789 140.934 405.826 144.201 401.989 146.01C398.152 147.82 393.757 148.024 389.77 146.579L409.418 91.9208C411.309 95.2784 413.527 102.1 410.359 113.286Z",
    fill: "#E0CCFC"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M409.565 91.5156L389.769 146.611C398.07 149.619 407.227 145.3 410.222 136.964L419.181 112.03C422.159 103.699 417.856 94.5197 409.565 91.5156V91.5156Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.36
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M605.252 120.301C599.537 120.301 594.904 115.649 594.904 109.91C594.904 104.171 599.537 99.5193 605.252 99.5193C610.966 99.5193 615.599 104.171 615.599 109.91C615.599 115.649 610.966 120.301 605.252 120.301Z",
    fill: "#7F56D9"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M605.252 99.5193C608.27 99.5199 611.138 100.847 613.1 103.151C609.88 101.843 604.759 100.5 601.714 103.584C597.104 108.231 612.986 110.537 609.299 119.488C605.438 121.129 600.972 120.268 597.99 117.307C595.009 114.347 594.102 109.872 595.693 105.976C597.284 102.08 601.059 99.534 605.252 99.5281V99.5193Z",
    fill: "#6445B1"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M605.252 120.301C599.537 120.301 594.904 115.649 594.904 109.91C594.904 104.171 599.537 99.5193 605.252 99.5193C610.966 99.5193 615.599 104.171 615.599 109.91C615.599 115.649 610.966 120.301 605.252 120.301Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M591.913 144.149C581.854 144.149 573.699 135.96 573.699 125.859C573.699 115.757 581.854 107.569 591.913 107.569C601.972 107.569 610.126 115.757 610.126 125.859C610.126 135.96 601.972 144.149 591.913 144.149Z",
    fill: "#7F56D9"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M591.913 107.569C594.086 107.572 596.241 107.967 598.274 108.735C591.79 108.355 582.657 109.848 579.322 120.301C573.928 137.204 593.022 127.122 593.136 134.951C593.25 142.779 605.454 135.49 604.838 138.75C599.023 144.627 590.001 145.845 582.847 141.719C575.693 137.592 572.194 129.152 574.319 121.147C576.444 113.142 583.663 107.571 591.913 107.569V107.569Z",
    fill: "#6445B1"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M591.913 144.149C581.854 144.149 573.699 135.96 573.699 125.859C573.699 115.757 581.854 107.569 591.913 107.569C601.972 107.569 610.126 115.757 610.126 125.859C610.126 135.96 601.972 144.149 591.913 144.149Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M418.902 558.139C433.86 538.585 429.989 535.873 437.186 521.135C451.264 519.226 460.802 502.845 460.802 502.845C464.718 511.433 468.378 518.749 471.361 524.139C457.221 547.006 419.466 571.684 418.902 558.139Z",
    fill: "#7F56D9"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M418.902 558.139C433.86 538.585 429.989 535.873 437.186 521.135C439.163 520.854 441.092 520.307 442.923 519.509C443.284 521.474 443.061 523.502 442.281 525.341C435.383 540.989 434.186 555.135 443.777 547.607C453.367 540.079 471.343 524.139 471.343 524.139C457.221 547.006 419.466 571.684 418.902 558.139Z",
    fill: "#E0CCFC"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M418.902 558.139C433.86 538.585 429.989 535.873 437.186 521.135C451.264 519.226 460.802 502.845 460.802 502.845C464.718 511.433 468.378 518.749 471.361 524.139C457.221 547.006 419.466 571.684 418.902 558.139V558.139Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.36
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M423.715 506.6C417.545 498.532 411.798 490.148 406.496 481.48C418.304 480.985 433.086 474.924 445.888 466.636C448.669 474.182 451.59 481.542 454.494 488.469C450.402 493.329 438.876 505.275 423.715 506.6Z",
    fill: "#F97ACC"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.72,
    d: "M423.715 485.023C415.295 485.624 425.475 494.027 434.001 504.02C430.722 505.397 427.254 506.266 423.715 506.6C417.545 498.532 411.798 490.148 406.496 481.48C418.304 480.985 433.086 474.924 445.888 466.636C445.888 466.636 438.066 484.007 423.715 485.023Z",
    fill: "#E224B1"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M423.715 506.6C417.545 498.532 411.798 490.148 406.496 481.48C418.304 480.985 433.086 474.924 445.888 466.636C448.669 474.182 451.59 481.542 454.494 488.469C450.402 493.329 438.876 505.275 423.715 506.6V506.6Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.36
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M460.767 502.845C460.767 502.845 451.229 519.226 437.151 521.135C433.711 518.537 429.039 513.465 423.715 506.6C438.876 505.275 450.402 493.346 454.511 488.469C456.632 493.523 458.743 498.365 460.785 502.845H460.767Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M434.001 504.02C438.269 509.039 442.087 514.464 442.888 519.509C441.057 520.307 439.128 520.854 437.151 521.135C433.711 518.537 429.039 513.466 423.716 506.6C427.254 506.267 430.722 505.397 434.001 504.02Z",
    fill: "#AFC0F9"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M460.767 502.845C460.767 502.845 451.229 519.226 437.151 521.135C433.711 518.537 429.039 513.465 423.715 506.6C438.876 505.275 450.402 493.346 454.511 488.469C456.632 493.523 458.743 498.365 460.785 502.845H460.767Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.36
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M299.767 452.234L299.406 452.013C299.406 448.478 297.866 442.293 290.933 431.867C280.057 415.574 266.665 399.431 261.078 397.319C261.168 397.152 261.284 396.999 261.421 396.869C266.507 392.354 290.457 414.77 295.877 411.457C296.152 411.158 296.41 410.846 296.652 410.52C300.726 414.602 310.994 426.027 313.537 439.545C307.157 445.987 302.248 450.537 299.767 452.234Z",
    fill: "#7F56D9"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M261.404 396.869C266.49 392.354 290.44 414.77 295.86 411.457C296.134 411.158 296.393 410.846 296.634 410.52C299.214 413.123 301.602 415.91 303.779 418.861C303.779 418.861 288.821 421.441 285.222 413.56C282.583 407.737 274.356 404.6 271.267 406.155C267.017 401.463 263.348 398.203 261.061 397.319C261.15 397.152 261.266 396.999 261.404 396.869Z",
    fill: "#B699ED"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M299.767 452.234L299.406 452.013C299.406 448.478 297.866 442.293 290.933 431.867C280.057 415.574 266.665 399.431 261.078 397.319C261.168 397.152 261.284 396.999 261.421 396.869C266.507 392.354 290.457 414.77 295.877 411.457C296.152 411.158 296.41 410.846 296.652 410.52C300.726 414.602 310.994 426.027 313.537 439.545C307.157 445.987 302.248 450.537 299.767 452.234V452.234Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.36
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M301.791 396.878C303.022 391.179 304.052 384.384 305.53 376.883C321.292 382.754 335.639 391.905 347.632 403.735C340.259 411.687 333.132 419.286 326.691 426.036C319.564 411.987 307.008 401.031 301.791 396.878Z",
    fill: "#F97ACC"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.72,
    d: "M311.672 392.204C309.718 394.855 309.155 398.849 308.794 402.984C305.979 400.333 303.515 398.23 301.755 396.878C302.987 391.179 304.017 384.384 305.495 376.883C321.269 382.75 335.629 391.901 347.632 403.735C347.632 403.735 317.558 384.19 311.672 392.204Z",
    fill: "#E224B1"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.791 396.878C303.022 391.179 304.052 384.384 305.53 376.883C321.292 382.754 335.639 391.905 347.632 403.735C340.259 411.687 333.132 419.286 326.691 426.036C319.564 411.987 307.008 401.031 301.791 396.878V396.878Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.36
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M296.652 410.52C299.054 407.401 300.532 402.709 301.79 396.878C307.008 401.03 319.564 411.943 326.682 426.036C321.86 431.09 317.417 435.667 313.537 439.545C310.994 426.027 300.726 414.637 296.652 410.52Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M301.791 396.878C303.498 398.229 305.979 400.315 308.83 402.983C308.258 409.628 308.205 416.599 303.832 418.887C301.655 415.937 299.267 413.149 296.687 410.547C299.054 407.401 300.532 402.709 301.791 396.878Z",
    fill: "#AFC0F9"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M296.652 410.52C299.054 407.401 300.532 402.709 301.79 396.878C307.008 401.03 319.564 411.943 326.682 426.036C321.86 431.09 317.417 435.667 313.537 439.545C310.994 426.027 300.726 414.637 296.652 410.52V410.52Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.36
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M482.711 202.014C479.324 234.601 490.313 248.764 511.158 239.61C516.71 237.172 522.966 233.081 529.829 227.24C566.185 196.315 620.518 196.792 626.906 287.854C633.294 378.915 572.001 419.833 572.001 419.833C553.066 379.913 524.224 349.43 507.638 337.793C531.395 312.32 536.604 286.042 531.017 289.656C523.238 293.685 512.055 295.841 500.362 295.32C498.963 295.267 497.555 295.179 496.147 295.046H496.077C486.772 293.755 477.721 291.034 469.24 286.979C428.995 267.081 431.564 221.135 437.213 195.14C453.051 212.299 482.711 202.014 482.711 202.014Z",
    fill: "#E0CCFC"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M437.213 195.14C441.132 199.301 446.159 202.245 451.695 203.622C442.342 210.947 463.864 231.013 458.127 252.74C452.302 274.83 494.202 293.385 533.85 273.805C559.613 261.09 570.356 258.033 570.453 264.183V264.245C570.369 265.77 570.008 267.267 569.388 268.662C566.968 276.986 559.481 295.974 537.809 317.736C525.192 330.416 569.564 340.1 561.68 362.719C554.307 383.854 580.853 397.497 572.951 419.162C572.344 419.612 572.01 419.833 572.01 419.833C553.075 379.913 524.233 349.43 507.647 337.793C518.584 326.077 525.579 314.202 529.406 305.101C530.82 301.87 531.917 298.509 532.679 295.064V294.913C532.75 294.551 532.811 294.207 532.855 293.88C532.86 293.803 532.86 293.726 532.855 293.65C532.896 293.338 532.932 293.043 532.961 292.766C532.957 292.705 532.957 292.643 532.961 292.581C532.961 292.263 532.961 291.962 532.961 291.697C532.961 291.635 532.961 291.582 532.961 291.521C532.961 291.459 532.961 291.141 532.961 290.964C532.951 290.872 532.937 290.78 532.917 290.69C532.902 290.58 532.882 290.471 532.855 290.363L532.776 290.107C532.749 290.031 532.717 289.957 532.679 289.886C532.647 289.815 532.608 289.747 532.565 289.683C532.222 289.206 531.685 289.153 530.955 289.63C523.177 293.659 511.993 295.815 500.3 295.293C498.901 295.24 497.493 295.152 496.085 295.019H496.015C486.71 293.729 477.659 291.008 469.179 286.952C428.995 267.081 431.564 221.135 437.213 195.14V195.14Z",
    fill: "#7F56D9"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M482.711 202.014C479.324 234.601 490.313 248.764 511.158 239.61C516.71 237.172 522.966 233.081 529.829 227.24C566.185 196.315 620.518 196.792 626.906 287.854C633.294 378.915 572.001 419.833 572.001 419.833C553.066 379.913 524.224 349.43 507.638 337.793C531.395 312.32 536.604 286.042 531.017 289.656C523.238 293.685 512.055 295.841 500.362 295.32C498.963 295.267 497.555 295.179 496.147 295.046H496.077C486.772 293.755 477.721 291.034 469.24 286.979C428.995 267.081 431.564 221.135 437.213 195.14C453.051 212.299 482.711 202.014 482.711 202.014V202.014Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.36
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M457.811 188.124C469.188 190.943 480.221 188.822 484.92 187.63C483.899 192.754 483.16 197.552 482.711 202.005C482.263 206.459 453.051 212.264 437.213 195.131C438.321 189.906 439.767 184.758 441.542 179.722C446.203 183.81 451.788 186.695 457.811 188.124Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M437.212 195.14C438.32 189.914 439.766 184.767 441.541 179.73C446.203 183.816 451.788 186.698 457.81 188.124C457.81 188.124 461.33 192.419 458.074 197.084C454.819 201.749 482.94 199.452 482.711 202.014C482.711 202.014 453.05 212.299 437.212 195.14Z",
    fill: "#AFC0F9"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M457.811 188.124C469.188 190.943 480.221 188.822 484.92 187.63C483.899 192.754 483.16 197.552 482.711 202.005C482.263 206.459 453.051 212.264 437.213 195.131C438.321 189.906 439.767 184.758 441.542 179.722C446.203 183.811 451.788 186.695 457.811 188.124V188.124Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.36
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M437.01 110.67L423.688 148.417L437.01 110.67Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M437.01 110.67L423.688 148.417",
    stroke: "#1C1C1C",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M467.938 125.859L457.547 155.3L467.938 125.859Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M467.938 125.859L457.547 155.3",
    stroke: "#1C1C1C",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M389.394 146.703C386.502 145.664 388.559 132.478 393.988 117.253C399.417 102.028 406.161 90.5278 409.053 91.5674C411.944 92.6071 409.887 105.792 404.459 121.018C399.03 136.243 392.285 147.743 389.394 146.703Z",
    fill: "white",
    stroke: "#1C1C1C",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M556.401 198.887L564.039 199.841L556.401 198.887Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M556.401 198.887L564.039 199.841",
    stroke: "#1C1C1C",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M556.401 198.887L564.039 199.841C562.692 200.539 558.187 206.485 553.753 206.026C554.562 203.932 556.401 198.887 556.401 198.887V198.887Z",
    fill: "#1C1C1C",
    stroke: "#1C1C1C",
    strokeWidth: 1.36
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M424.56 347.822C424.56 347.822 426.725 364.195 432.356 377.607",
    stroke: "#1C1C1C",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M552.424 165.885C552.424 165.885 549.477 171.363 546.45 172.865C545.878 175 545.346 176.601 550.216 178.078",
    stroke: "#1C1C1C",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M562.05 172.379C559.278 167.308 554.685 169.923 554.685 169.923",
    stroke: "#1C1C1C",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M569.582 261.214C569.582 261.214 547.259 281.474 528.57 290.814",
    stroke: "#1C1C1C",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M404.112 107.94C404.112 107.94 408.837 100.65 407.412 98.0879C405.986 95.5256 399.546 107.913 397.152 119.523C394.759 131.134 400.742 113.285 404.112 107.94Z",
    fill: "#C5ABF2"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M393.201 131.567C393.201 131.567 395.973 123.438 396.598 125.32C397.222 127.202 392.505 138.255 393.201 131.567Z",
    fill: "#C5ABF2"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M589.282 218.078C589.282 218.078 610.716 227.47 611.332 244.717C611.947 261.965 605.938 232.683 593.954 235.095C581.97 237.507 577.016 213.094 589.282 218.078Z",
    fill: "white"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M569.582 216.037C569.582 216.037 579.173 214.269 577.774 221.25C576.375 228.23 557.994 218.484 569.582 216.037Z",
    fill: "white"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M476.394 209.215C476.394 209.215 480.292 215.021 474.704 215.825C469.117 216.629 465.897 206.998 476.394 209.215Z",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M464.515 208.888C464.515 208.888 467.568 208.782 467.155 211.106C466.741 213.43 460.114 211.769 464.515 208.888Z",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M441.912 118.176C441.912 118.176 452.487 121.025 452.333 123.415C452.18 125.806 444.977 120.97 447.601 125.53C450.224 130.091 430.963 115.719 441.912 118.176Z",
    fill: "white"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M455.556 125.751C455.556 125.751 459.095 124.344 459.724 126.893C460.353 129.441 455.064 129.092 455.556 125.751Z",
    fill: "white"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M565.772 140.579C565.772 140.579 581.17 145.474 584.759 158.392C588.349 171.31 576.973 148.788 569.582 147.506C562.191 146.225 560.959 140.553 565.772 140.579Z",
    fill: "white"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M586.958 167.281C586.958 167.281 588.956 165.381 590.355 168.942C591.755 172.503 587.557 174.305 586.958 167.281Z",
    fill: "white"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M595.758 110.688C595.758 110.688 603.967 113.842 605.261 118.516C606.554 123.19 588.587 110.06 595.758 110.688Z",
    fill: "white"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M610.135 102.17C610.135 102.17 613.866 106.411 613.101 107.569C612.335 108.726 606.535 103.248 610.135 102.17Z",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M490.463 167.281C490.463 167.281 497.669 163.482 496.877 162.28C496.085 161.078 487.287 162.978 486.882 168.297C486.477 173.616 488.791 168.218 490.463 167.281Z",
    fill: "white"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M485.086 173.121C485.086 173.121 486.794 171.902 486.847 173.607C486.899 175.311 485.086 175.638 485.086 173.121Z",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M522.138 163.181C522.138 163.181 522.737 168.818 520.941 170.815C519.146 172.812 520.484 160.972 522.138 163.181Z",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M419.122 311.1C419.122 311.1 428.132 303.661 425.73 301.54C423.328 299.419 401.481 306.753 397.248 327.367C393.016 347.981 408.713 319.388 419.122 311.1Z",
    fill: "white"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M394.706 342.962C394.706 342.962 396.395 336.591 392.065 338.712C387.736 340.833 392.312 350.181 394.706 342.962Z",
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M500.379 339.596C493.725 334.239 485.111 331.989 476.701 333.41C462.113 335.611 490.084 339.021 485.685 343.236C481.286 347.45 509.776 344.694 500.379 339.596Z",
    fill: "white"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M467.912 333.013C467.912 333.013 460.116 328.153 456.526 332.368C452.936 336.583 471.695 336.052 467.912 333.013Z",
    fill: "white"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M341.473 401.455C341.473 401.455 342.071 406.597 334.882 411.413C327.694 416.228 337.795 400.73 341.473 401.455Z",
    fill: "white"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M445.888 474.995C445.888 474.995 452.127 485.297 449.936 488.469C447.745 491.641 442.941 475.604 445.888 474.995Z",
    fill: "white"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M599.277 374.32C598.468 376.005 597.626 377.704 596.752 379.418",
    stroke: "white",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M618.925 278.92C621.055 297.043 620.148 327.049 603.167 365.9",
    stroke: "white",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M617.104 268.194C617.394 269.466 617.685 270.845 617.984 272.408",
    stroke: "white",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M614.455 259.358C614.455 259.358 614.966 260.551 615.679 262.893",
    stroke: "white",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M478.109 229.299C479.799 234.538 483.037 240.785 489.082 242.817",
    stroke: "white",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M476.394 221.453C476.394 221.453 476.49 222.496 476.799 224.104",
    stroke: "white",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M439.544 332.801C433.984 332.863 427.05 333.384 423.707 335.452",
    stroke: "white",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M447.675 333.013C447.675 333.013 446.337 332.915 444.26 332.854",
    stroke: "white",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M442.571 414.744C447.639 422.555 454.889 431.125 464.11 435.499",
    stroke: "white",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M437.837 406.597C438.532 407.94 439.324 409.389 440.213 410.909",
    stroke: "white",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M434.027 398.371C434.027 398.371 434.564 399.767 435.603 402.038",
    stroke: "white",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M379.114 367.808C375.443 376.068 372.699 384.713 370.931 393.582",
    stroke: "white",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M383.337 358.813C382.809 359.847 382.255 360.96 381.683 362.144",
    stroke: "white",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M388.107 350.234C388.107 350.234 387.341 351.453 386.127 353.644",
    stroke: "white",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M517.643 174.95L513.973 184.21",
    stroke: "white",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M468.28 130.701L479.973 136.038",
    stroke: "white",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M414.177 97.7521C414.177 97.7521 419.07 101.976 414.177 115.079",
    stroke: "white",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M591.912 176.169C591.912 176.169 598.073 189.582 591.912 191.075",
    stroke: "white",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M605.314 122.793C605.314 122.793 607.804 141.039 590.638 138.22",
    stroke: "white",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M293.142 426.91C289.702 421.671 285.749 416.79 281.342 412.34",
    stroke: "white",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M308.795 438.088C308.795 438.088 304.176 445.245 296.653 432.486",
    stroke: "white",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M459.139 531.694C457.73 533.327 456.175 534.826 454.492 536.173",
    stroke: "white",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M460.767 512.573C460.767 512.573 466.927 519.05 461.594 528.265",
    stroke: "white",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M322.996 312.231C321.724 314.105 320.549 316.042 319.476 318.037",
    stroke: "#1C1C1C",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M352.26 287.774C342.836 292.005 334.452 298.264 327.703 306.108",
    stroke: "#1C1C1C",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M288.135 402.038C288.135 402.038 295.06 407.127 293.142 415.636",
    stroke: "#1C1C1C",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M281.343 399.617C281.343 399.617 288.927 402.524 286.534 412.349",
    stroke: "#1C1C1C",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M275.131 397.647C275.131 397.647 282.944 399.864 281.43 409.866",
    stroke: "#1C1C1C",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M428.159 532.233C428.159 532.233 433.438 525.447 441.85 527.638",
    stroke: "#1C1C1C",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M425.528 538.974C425.528 538.974 428.66 531.455 438.356 534.159",
    stroke: "#1C1C1C",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M423.381 545.151C423.381 545.151 425.836 537.375 435.7 539.204",
    stroke: "#1C1C1C",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M257.638 417.35C258.518 418.897 259.556 420.531 260.727 422.245",
    stroke: "#1C1C1C",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M255.773 389.747C255.773 389.747 248.037 395.049 254.118 410.229",
    stroke: "#1C1C1C",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M412.848 506.229C413.734 507.266 414.644 508.288 415.577 509.295",
    stroke: "#1C1C1C",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M405.906 497.473C406.997 498.957 408.123 500.442 409.294 501.891",
    stroke: "#1C1C1C",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M381.684 452.234C386.835 466.056 393.558 479.235 401.719 491.509",
    stroke: "#1C1C1C",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M638.74 282.252C638.957 284.06 639.142 285.901 639.295 287.774",
    stroke: "#1C1C1C",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M636.233 267.858C636.743 270.094 637.218 272.4 637.641 274.759",
    stroke: "#1C1C1C",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M615.072 219.783C615.072 219.783 626.44 234.592 633.725 258.572",
    stroke: "#1C1C1C",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M451.581 284.001C452.741 284.683 453.964 285.251 455.233 285.697",
    stroke: "#1C1C1C",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M435.937 261.779C435.937 261.779 439.237 273.495 447.375 280.909",
    stroke: "#1C1C1C",
    strokeWidth: 1.36,
    strokeLinecap: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M187.873 212.46C187.873 212.46 155.691 248.621 108.98 230.189C62.268 211.756 99.605 179.986 120.501 191.557C141.397 203.128 163.769 208.16 170.626 194.135C177.483 180.11 210.612 186.438 187.873 212.46Z",
    fill: "#F4EBFF"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M131.36 165.624C170.455 168.948 204.856 139.819 208.197 100.563C211.538 61.3066 182.554 26.7884 143.459 23.4645C104.364 20.1405 69.9634 49.2695 66.6223 88.5259C63.2812 127.782 92.2653 162.3 131.36 165.624Z",
    fill: "#D6BBFB"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M208.219 100.622C210.211 77.1369 200.522 54.1801 182.331 39.2852C164.141 24.3903 139.797 19.4804 117.29 26.1668C117.707 26.3513 118.136 26.5369 118.597 26.7253C118.597 26.7253 161.154 13.8134 185.893 65.0568C210.632 116.3 170.889 168.253 94.116 151.125C114.704 167.032 142.297 170.384 166.068 159.864C189.838 149.344 205.993 126.631 208.192 100.639L208.219 100.622Z",
    fill: "#F9F5FF"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M166.525 159.707C165.907 159.991 165.279 160.248 164.649 160.524",
    stroke: "#101828",
    strokeWidth: 1.44,
    strokeLinecap: "round"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M170.936 157.493C170.259 157.875 169.531 158.24 168.816 158.606",
    stroke: "#101828",
    strokeWidth: 1.44,
    strokeLinecap: "round"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4276 65.7517C84.8299 37.5934 113.819 20.5977 144.333 23.5952C174.848 26.5927 200.004 48.9072 206.731 78.9447C213.459 108.982 200.24 139.967 173.944 155.801",
    stroke: "#101828",
    strokeWidth: 1.44,
    strokeLinecap: "round"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2464 71.349C70.5634 70.424 70.8921 69.5131 71.2465 68.6042",
    stroke: "#101828",
    strokeWidth: 1.44,
    strokeLinecap: "round"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M155.523 163.585C130.922 170.052 104.755 162.836 86.8941 144.659C69.0333 126.481 62.1978 100.11 68.9668 75.4948",
    stroke: "#101828",
    strokeWidth: 1.44,
    strokeLinecap: "round"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M143.456 23.4926C122.254 21.6602 101.354 29.4902 86.5273 44.8202C84.4069 53.6348 88.5358 62.6788 98.5536 67.9839C121.503 80.1317 128.144 50.9981 125.056 40.0159C122.373 30.4996 142.694 29.2174 144.376 23.5971C144.069 23.5644 143.764 23.5189 143.456 23.4926Z",
    fill: "#F9F5FF"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M144.402 23.5994C144.095 23.5732 143.762 23.5447 143.48 23.5207C134.456 22.7279 125.363 23.6815 116.697 26.3297C113.326 28.7359 111.203 32.3367 111.862 37.7232C113.925 53.9544 109.345 64.8515 99.5794 68.5184C121.709 79.2297 128.098 50.8583 125.057 40.016C122.374 30.4997 142.692 29.2433 144.402 23.5994Z",
    fill: "#7F56D9"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M125.552 49.8442C125.738 48.1943 125.801 46.5328 125.741 44.8735",
    stroke: "#101828",
    strokeWidth: 1.44,
    strokeLinecap: "round"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M125.056 40.0157C122.373 30.4994 142.694 29.2172 144.376 23.5969C144.069 23.5707 143.736 23.5422 143.454 23.5182C122.252 21.6858 101.352 29.5157 86.5253 44.8457C84.4049 53.6603 88.5338 62.7043 98.5517 68.0094C113.816 76.0941 121.87 65.9018 124.637 54.9404",
    stroke: "#101828",
    strokeWidth: 1.44,
    strokeLinecap: "round"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M155.522 425.261C155.522 425.261 37.5232 417.75 16.3943 311.021C3.91236 247.936 35.0029 180.653 83.9346 141.511",
    stroke: "#7F56D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6.03 6.03"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M174.778 33.8945C169.127 34.4416 159.525 37.4748 154.618 51.09C147.355 71.1293 180.424 64.2331 177.655 78.6462C174.886 93.0594 170.262 116.582 190.649 118.79C210.53 120.941 181.334 131.303 192.059 140.204C205.225 124.322 210.882 103.486 207.567 83.0908C204.252 62.6958 192.289 44.7479 174.778 33.8945V33.8945Z",
    fill: "#F9F5FF"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M174.776 33.8946C174.341 33.9351 173.878 33.9992 173.394 34.0744C176.43 37.2093 200.25 62.6823 197.125 86.7925C194.103 110.057 183.701 86.2934 175.19 95.9287C174.712 106.982 177.419 117.355 190.622 118.787C210.504 120.939 181.307 131.301 192.033 140.202C205.2 124.324 210.861 103.49 207.55 83.096C204.24 62.7019 192.283 44.7524 174.776 33.8946V33.8946Z",
    fill: "#7F56D9"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M155.113 61.3065C155.913 62.3681 156.898 63.2752 158.021 63.9836",
    stroke: "#101828",
    strokeWidth: 1.44,
    strokeLinecap: "round"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M190.623 118.787C210.504 120.939 181.308 131.301 192.033 140.202C205.201 124.323 210.862 103.49 207.551 83.0959C204.241 62.7018 192.284 44.7523 174.777 33.8945C169.126 34.4416 159.524 37.4748 154.618 51.09C154.055 52.5568 153.707 54.0978 153.585 55.6648",
    stroke: "#101828",
    strokeWidth: 1.44,
    strokeLinecap: "round"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M183.019 116.428C184.35 117.2 185.781 117.784 187.271 118.164",
    stroke: "#101828",
    strokeWidth: 1.44,
    strokeLinecap: "round"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M161.602 65.8633C169.198 69.1416 179.2 70.4494 177.629 78.6438C175.702 88.6795 172.87 103.146 178.225 111.724",
    stroke: "#101828",
    strokeWidth: 1.44,
    strokeLinecap: "round"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1491 127.506C83.213 128.717 91.746 115.464 91.0341 96.4594C90.5306 82.913 75.4434 84.843 66.8061 87.0714C66.7647 87.56 66.6912 88.046 66.6499 88.5347C63.6568 123.882 86.9823 156.067 121.397 164.076C138.372 139.323 112.591 126.344 98.1491 127.506Z",
    fill: "#F9F5FF"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1486 127.506C83.2126 128.717 91.7456 115.464 91.0337 96.4594C90.9231 93.4255 90.0736 91.1963 88.7322 89.5209C89.6791 95.0161 90.6949 106.702 85.3143 118.373C77.9229 134.366 97.6494 140.708 104.068 139.857C108.555 139.263 108.332 149.431 99.7472 155.077C106.41 159.279 113.727 162.332 121.393 164.108C138.372 139.323 112.59 126.344 98.1486 127.506Z",
    fill: "#7F56D9"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0651 100.277C91.0928 99.0354 91.0825 97.7609 91.0342 96.4528",
    stroke: "#101828",
    strokeWidth: 1.44,
    strokeLinecap: "round"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M126.948 149.849C127.846 134.447 109.496 126.623 98.1454 127.538C85.528 128.559 89.6482 119.28 90.8122 104.931",
    stroke: "#101828",
    strokeWidth: 1.44,
    strokeLinecap: "round"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7398 89.5085C84.0977 83.7818 73.512 85.3321 66.8063 87.0649C66.7649 87.5536 66.6915 88.0395 66.6501 88.5282C63.657 123.875 86.9825 156.061 121.397 164.07C123.379 161.277 124.929 158.2 125.995 154.942",
    stroke: "#101828",
    strokeWidth: 1.44,
    strokeLinecap: "round"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M94.6134 87.6269C105.784 88.5812 115.611 80.2608 116.561 69.0428C117.511 57.8248 109.226 47.9572 98.0547 47.0029C86.8836 46.0486 77.0573 54.369 76.107 65.5871C75.1567 76.8051 83.4423 86.6726 94.6134 87.6269Z",
    fill: "white"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M114.764 90.2486C114.764 90.2486 104.283 93.388 105.274 105.435C106.266 117.481 129.417 101.752 127.854 118.373C126.291 134.994 153.424 134.229 147.396 112.271C141.369 90.3127 126.296 83.7728 114.764 90.2486Z",
    fill: "#F9F5FF"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M146.387 109.031C147.115 120.692 135.148 122.487 135.712 114.913C136.377 106 128.289 103.56 116.844 106.889C110.297 108.797 106.93 105.757 105.246 102.803C105.193 103.68 105.202 104.559 105.274 105.435C106.272 117.482 129.416 101.752 127.854 118.373C126.291 134.994 153.423 134.229 147.396 112.271C147.084 111.163 146.749 110.091 146.387 109.031Z",
    fill: "#7F56D9"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M122.743 87.8925C121.797 87.9533 120.858 88.0896 119.934 88.3",
    stroke: "#101828"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M128.236 123.082C131.649 134.636 152.781 131.927 147.388 112.296C143.406 97.7921 135.475 90.0035 127.226 88.2561",
    stroke: "#101828"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M114.765 90.2485C114.765 90.2485 104.283 93.3879 105.275 105.435C106.267 117.481 129.417 101.752 127.855 118.373",
    stroke: "#101828"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M206.351 111.945C304.361 138.593 224.475 199.182 176.22 129.227C127.363 58.392 96.7016 69.7489 96.7016 69.7489",
    stroke: "#7F56D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6.03 6.03"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M102.93 58.0473L81.877 64.8496C81.5362 64.9561 81.2885 65.2524 81.2431 65.608C81.1978 65.9636 81.363 66.313 81.6661 66.5025L100.334 78.4141C100.662 78.6346 101.093 78.6204 101.406 78.3786C101.719 78.1368 101.843 77.7215 101.714 77.3468L99.4964 70.7133L107.563 72.6393L108.021 69.0517L108.48 65.4641L100.167 65.311L103.961 59.4242C104.163 59.1004 104.145 58.6852 103.917 58.3799C103.688 58.0746 103.296 57.9424 102.93 58.0473Z",
    fill: "white"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M100.167 65.3108L103.962 59.4241C104.176 59.0969 104.162 58.6698 103.925 58.3584C103.689 58.0469 103.283 57.919 102.912 58.0391L100.843 58.7043C100.932 60.0913 100.844 62.2728 99.5652 63.1286C97.6216 64.4457 98.8828 66.3862 100.389 65.5823C100.546 65.4913 100.696 65.387 100.835 65.2707L100.167 65.3108Z",
    fill: "#5AB9F9"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M108.002 69.05L108.46 65.4624L106.742 65.4256C105.76 66.3585 104.818 67.5798 104.904 68.7659C105.088 71.165 98.8378 65.5406 98.0156 67.9379C97.1934 70.3351 94.2511 73.5487 81.2487 65.6377C81.2847 65.8221 81.3346 65.9948 81.3775 66.1733C81.4499 66.297 81.5489 66.4028 81.6673 66.483L100.335 78.3946C100.663 78.6152 101.095 78.6009 101.407 78.3591C101.72 78.1174 101.844 77.7021 101.715 77.3274L99.4976 70.6939L107.564 72.6199L108.002 69.05Z",
    fill: "#7F56D9"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.93 58.0473L81.877 64.8496C81.5362 64.9561 81.2885 65.2524 81.2431 65.608C81.1978 65.9636 81.363 66.313 81.6661 66.5025L100.334 78.4141C100.662 78.6346 101.093 78.6204 101.406 78.3786C101.719 78.1368 101.843 77.7215 101.714 77.3468L99.4964 70.7133L107.563 72.6393L108.021 69.0517L108.48 65.4641L100.167 65.311L103.961 59.4242C104.163 59.1004 104.145 58.6852 103.917 58.3799C103.688 58.0746 103.296 57.9424 102.93 58.0473V58.0473Z",
    stroke: "#101828",
    strokeWidth: 1.44
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M109.215 69.1719C109.471 67.1711 109.295 65.4999 108.823 65.4392C108.352 65.3784 107.762 66.9512 107.507 68.9521C107.251 70.9529 107.427 72.6241 107.899 72.6849C108.371 72.7456 108.96 71.1728 109.215 69.1719Z",
    fill: "#161616",
    stroke: "#101828",
    strokeWidth: 1.44
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8786 409.048C94.8786 409.048 35.607 401.996 16.3232 339.037",
    stroke: "white",
    strokeWidth: 1.44,
    strokeLinecap: "round"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5967 390.452C38.5967 390.452 53.7113 405.557 63.2347 406.345",
    stroke: "white",
    strokeWidth: 1.44,
    strokeLinecap: "round"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M141.864 81.722C141.864 81.722 158.465 91.3069 181.938 129.185",
    stroke: "white",
    strokeWidth: 1.44,
    strokeLinecap: "round"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M156.019 87.6135C156.019 87.6135 163.689 95.2826 166.353 99.4608",
    stroke: "white",
    strokeWidth: 1.44,
    strokeLinecap: "round"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6479 56.2273C95.6479 56.2273 77.4524 61.4278 77.554 65.7109C77.6555 69.9941 92.4881 79.2919 92.4881 79.2919",
    stroke: "white",
    strokeWidth: 1.44,
    strokeLinecap: "round"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M171.604 37.4701C171.604 37.4701 156.534 45.5153 159.603 54.5013C162.673 63.4872 171.639 41.087 172.282 47.1974C172.926 53.3078 179.442 33.943 171.604 37.4701Z",
    fill: "white"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M170.275 53.1655C170.275 53.1655 166.704 55.5676 167.967 58.4734C169.231 61.3791 174.909 54.5846 170.275 53.1655Z",
    fill: "white"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M106.124 35.4906C106.124 35.4906 121.191 26.4154 123.534 27.9108C125.878 29.4063 113.198 33.9058 115.895 36.3252C118.592 38.7447 98.9747 41.013 106.124 35.4906Z",
    fill: "white"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M114.754 41.1174C114.754 41.1174 118.67 38.2137 118.976 40.5454C119.282 42.8771 113.028 44.5838 114.754 41.1174Z",
    fill: "white"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M180.427 95.1841C180.145 103.761 182.023 113.72 192.133 114.208",
    stroke: "white",
    strokeWidth: 1.44,
    strokeLinecap: "round"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M182.15 82.7604C181.637 84.9013 181.238 87.068 180.955 89.2514",
    stroke: "white",
    strokeWidth: 1.44,
    strokeLinecap: "round"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8599 229.571C30.8599 229.571 20.8095 242.313 21.7308 275.214",
    stroke: "white",
    strokeWidth: 1.44,
    strokeLinecap: "round"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7081 89.473C77.7081 89.473 66.7464 90.5896 69.8191 96.5708C72.8918 102.552 79.5153 93.034 78.3958 99.2464C77.2762 105.459 87.1001 88.1575 77.7081 89.473Z",
    fill: "white"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M73.902 101.589C73.902 101.589 68.5617 103.723 70.3362 108.357C72.1107 112.99 78.4261 103.608 73.902 101.589Z",
    fill: "white"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4043 126.242C84.4641 135.793 92.8721 147.845 104.155 150.933",
    stroke: "white",
    strokeWidth: 1.44,
    strokeLinecap: "round"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8438 113.779C73.8438 113.779 74.7334 116.374 76.4536 120.206",
    stroke: "white",
    strokeWidth: 1.44,
    strokeLinecap: "round"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M118.354 92.9452C118.354 92.9452 108.678 94.5732 109.608 101.861C110.539 109.149 117.598 92.5115 122.083 95.6794C126.567 98.8474 125.018 89.8035 118.354 92.9452Z",
    fill: "white"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M128.209 93.7867C128.209 93.7867 137.936 95.8287 142.49 109.98",
    stroke: "white",
    strokeWidth: 1.44,
    strokeLinecap: "round"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M105.588 173.755C107.412 173.386 109.343 173.046 111.362 172.739",
    stroke: "#7F56D9",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6.03 6.03"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M143.929 171.176C164.137 172.067 179.189 176.332 179.29 181.761C179.398 188.098 158.892 193.554 133.506 193.95C108.12 194.346 87.4442 189.543 87.3356 183.212C87.2913 180.081 92.2791 177.158 100.404 174.964",
    stroke: "#7F56D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6.03 6.03"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M156.591 188.811C162.246 190.188 165.739 192.125 165.799 194.312C165.869 198.813 151.294 202.697 133.244 202.982C115.194 203.266 100.501 199.848 100.431 195.347C100.391 193.084 104.026 190.978 109.963 189.413",
    stroke: "#7F56D9",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6.03 6.03"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M151.999 187.901C152.699 188.012 153.379 188.135 154.039 188.263",
    stroke: "#7F56D9",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6.03 6.03"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_129_10769",
    x1: 480.947,
    y1: 45.925,
    x2: 651.212,
    y2: 407.149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4EAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4EAFF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcn);
export default __webpack_public_path__ + "static/media/home-icn.71222140e478f0e45abe7813390601b3.svg";
export { ForwardRef as ReactComponent };